module.exports = __webpack_public_path__ + "img/upload.4aebbce9.svg";